import { render, staticRenderFns } from "./Antecedents.vue?vue&type=template&id=7bd468b5&scoped=true"
import script from "./Antecedents.vue?vue&type=script&lang=js"
export * from "./Antecedents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd468b5",
  null
  
)

export default component.exports